<template>
  <div class="articleDetail">
    <div class="detailHead">
      <div class="name">
        <p
          :span="24"
          class="title"
          v-if="isInput"
          @click="updateInput"
        >{{articleDetails.title}}</p>
        <el-row
          class="input"
          v-else
        >
          <el-col :span="24">
            <el-input
              type="text"
              v-model="articleDetails.title"
              v-focus
              @blur="inputBlur"
              @change="updateCon"
              @keyup.native.enter="updateCon"
            />
          </el-col>
        </el-row>

        <div
          class="compile"
          v-if="isInput"
          @click="updateInput"
        >
          <ig-icon name="brush"></ig-icon>
        </div>
      </div>
      <div class="keyword">
        <div class="keywordItem">
          <div class="title">关键词：</div>
          <div class="items">
            <p>{{articleDetails.keyName}} {{articleDetails.zhKeyName ? articleDetails.zhKeyName : ''}}</p>
          </div>
        </div>
        <div class="switch">
          <el-switch
            v-model="useFlag"
            inactive-text="是否使用"
            @change="updateSwitch"
          ></el-switch>
        </div>
      </div>
      <div class="info">
        <p class="title">{{articleDetails.customerName }}</p>
        <p class="webUrl">{{articleDetails.domainName}}</p>
      </div>
    </div>
    <!-- 伪原创 -->
    <div class="detailContent">
      <article-detail
        class="original"
        :name="title"
        :content="articleDetails.content"
        :pseudoZhContent="pseudoZhContent"
        :pseudoContent="pseudoContent"
        @dialogShow="dialogShow"
      ></article-detail>
    </div>
    <!-- 人工校验 -->
    <div class="verify">
      <div class="title">人工校验</div>
      <div class="editor">
        <quill-editor
          ref="myTextEditor"
          v-model="pseudoManualContent"
        ></quill-editor>
      </div>
      <div class="btn">
        <el-button
          type="primary"
          size="small"
          plain
          @click="download(pseudoManualContent)"
        >导出文档</el-button>
        <el-button
          type="primary"
          size="small"
          plain
          v-clipboard:copy="pseudoManualContent"
          v-clipboard:success="onCopy"
        >复制文本</el-button>
        <el-button
          type="primary"
          size="small"
          @click="savearticle"
        >保存更新</el-button>
      </div>
    </div>
    <!-- 对话框 -->
    <el-dialog
      class="modal"
      :visible.sync="dialogVisible"
      title="原文"
      width="50%"
    >
      <el-tabs
        value="en"
        v-loading="loading"
      >
        <el-tab-pane
          label="中文"
          name="zh"
        >
          <div
            class="content"
            ref="pseudoEng"
            v-html="zhContent"
          >
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="英文"
          name="en"
        >
          <div
            class="content"
            ref="pseudoEng"
            v-html="articleDetails.content"
          >
          </div>
        </el-tab-pane>
      </el-tabs>
      <div
        class="bottom"
        v-if="isShowBottom"
      >
        <div class="text">
          <p>这是一篇有效文章吗？</p>
          <p>无效的文章会从后台删除，减少数据干扰</p>
        </div>
        <div class="button">
          <el-button
            type="danger"
            @click="cancel"
            :loading="confirmLoad"
          >删除</el-button>
          <el-button
            type="primary"
            :loading="confirmLoad"
            @click="confirm"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import articleDetail from '@/components/SEO/article'
import seo from '@/backend/services/seo/seoBoard.js'
export default {
  data() {
    return {
      id: '',
      pseudoManualContent: '', // 富文本内容
      pseudoZhContent: '', // 伪原创中文内容
      pseudoContent: '', // 伪原创英文内容
      zhContent: '',
      title: '',
      isInput: true,
      statu: true,
      articleDetails: '',
      useFlag: false,
      dialogVisible: false,
      confirmLoad: false,
      isShowBottom: true,
      loading: false
    }
  },
  created() {
    this.getSeoArticleDetail()
  },
  methods: {
    inputBlur() {
      this.isInput = true
    },
    // 修改标题
    async updateCon() {
      let id = this.articleDetails.articleId
      let title = this.articleDetails.title
      let res = await seo.compiletitle({
        articleId: id,
        title
      })
      if (res.status === 200) {
        this.isInput = true
        this.$message({
          message: '修改成功',
          type: 'success',
          duration: 2000
        })
      }
    },
    updateInput() {
      this.isInput = false
    },
    // 是否使用
    async updateSwitch() {
      let id = this.articleDetails.articleId
      let useFlag = this.useFlag ? 1 : 0
      await seo.articleuseswitch({
        articleId: id,
        useFlag
      })
    },
    // 复制文本
    onCopy() {
      this.$message({
        message: '复制到剪切板成功',
        type: 'success',
        duration: 1500
      })
    },
    // 导出文档
    download(data) {
      if (!data) {
        this.$message({
          message: '内容为空，无法导出'
        })
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '文档.txt')

      document.body.appendChild(link)
      link.click()
    },
    // 保存更新
    async savearticle() {
      let id = this.articleDetails.articleId
      let pseudoId = this.articleDetails.pseudoId
      let content = this.pseudoManualContent
      let res = await seo.savearticle({
        articleId: id,
        pseudoArticleId: pseudoId,
        manualContent: content
      })
      if (res.status === 200) {
        // 请求数据
        this.getSeoArticleDetail()
        // 清空数据
        this.pseudoManualContent = ''
        this.pseudoZhContent = ''
        this.pseudoContent = ''
        this.title = ''
      }
    },
    // 请求详情数据
    async getSeoArticleDetail() {
      this.id = this.$route.query.id
      let id = this.$route.query.articleId
      let res = await seo.seoarticledetail(id)
      // 文章详情
      this.articleDetails = res.data
      this.zhContent = res.data.zhContent || ''
      // 是否使用
      this.useFlag = this.articleDetails.useFlag === 0 ? false : true
      if (res.data.effectiveFlag === 2) {
        this.isShowBottom = false
        this.pseudoManualContent = this.articleDetails.pseudoManualContent
        this.pseudoZhContent = this.articleDetails.pseudoZhContent
        this.pseudoContent = this.articleDetails.pseudoContent
        this.title = this.articleDetails.title
      }
    },
    // 显示模态框
    async dialogShow() {
      this.dialogVisible = true
      if (this.isShowBottom) {
        this.loading = true
        let res = await seo.translation(this.articleDetails.articleId)
        this.zhContent = res.data
        this.loading = false
      }
    },
    // 取消
    async cancel() {
      this.confirmLoad = true
      this.dialogVisible = false
      let id = this.articleDetails.articleId
      let res = await seo.setarticlevalid({
        articleId: id,
        effectiveFlag: 1
      })
      if (res.status === 200) {
        this.confirmLoad = false
        this.$router.push({
          path: '/seo/articleAssistant/',
          query: { id: this.id }
        })
      }
    },
    // 确定
    async confirm() {
      this.confirmLoad = true
      let id = this.articleDetails.articleId
      let res = await seo.setarticlevalid({
        articleId: id,
        effectiveFlag: 2
      })

      if (res.status === 200) {
        this.confirmLoad = false
        this.$message({
          message: '已设为有效文章',
          type: 'success'
        })
        this.getSeoArticleDetail()
        this.dialogVisible = false
        this.pseudoManualContent = res.data.pseudoManualContent
        this.pseudoZhContent = res.data.pseudoZhContent
        this.pseudoContent = res.data.pseudoContent
        this.title = this.articleDetails.title
      } else if (res.status === 400) {
        this.$message({
          message: '转换文章失败，请重新确认文章',
          type: 'info',
          duration: 2000
        })
      } else {
        this.$message({
          message: '失败！请稍后再试',
          type: 'info',
          duration: 2000
        })
      }
    }
  },
  // 指令的定义
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  components: { articleDetail }
}
</script>

<style scoped lang="scss">
.articleDetail {
  background-color: #f1f4f9;
  .detailHead {
    padding: 30px 20px 20px;
    background-color: #fff;
    .name {
      .title {
        // padding: 11px 0;
      }
      .input {
        width: 50%;
      }
      .compile {
        color: #999;
        // padding: 5px;
        i {
          font-size: 18px;
        }
      }
    }
    .keyword {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .keywordItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 14px;
        }
        .items {
          font-size: 14px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          p {
            color: #333;
            padding: 7px 10px;
            background-color: #ecf6ff;
            border-radius: 14px;
            margin: 5px 10px 5px 0;
          }
        }
      }
      .switch {
        margin-right: 50px;
      }
    }
    .info {
      .webUrl {
        color: #54a8fe;
      }
    }
    .name,
    .info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      color: #333;
      margin: 7px 0;
    }
    .title {
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .detailContent {
    margin: 10px 0;
  }
  .verify {
    background-color: #fff;
    padding: 20px;
    font-size: 16px;
    color: #333;
    .editor {
      margin-top: 20px;
    }
    .btn {
      padding: 20px 0 15px;
      display: flex;
      justify-content: flex-end;
    }
  }
  .modal {
    .content {
      width: 100%;
      height: 400px;
      font-size: 12px;
      line-height: 21px;
      overflow: auto;
      padding-right: 10px;
    }
    // 改变滚动条样式
    .content::-webkit-scrollbar {
      width: 4px;
    }
    .content::-webkit-scrollbar-thumb {
      background-color: #d8d8d8;
      border-radius: 2px;
    }
    .content::-webkit-scrollbar-track {
      background-color: #fff;
      border-radius: 2px;
    }
    .bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      .text {
        text-align: center;
        line-height: 25px;
        padding: 20px 0;
      }
      .button {
        width: 24%;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
